import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var CompanyMemoApi = /** @class */ (function () {
    function CompanyMemoApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    CompanyMemoApi.initialize = function (basePath, fetchApi) {
        if (!CompanyMemoApi.instance) {
            CompanyMemoApi.instance = new CompanyMemoApi(basePath, fetchApi);
        }
        return CompanyMemoApi.instance;
    };
    CompanyMemoApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1CompanyMemoApi(new Configuration(config));
    };
    return CompanyMemoApi;
}());
export { CompanyMemoApi };
